import styled from "styled-components";
import {
    Layout,
    Space,
} from "antd";
import { logo } from '@assets';

const {
    Header: AntHeader,
} = Layout;

export const Header = styled(AntHeader)`
height: 80px;
position: sticky;
top: 0;
padding: 0 18px !important;
background: ${props => props.theme.primaryColor} !important;
box-shadow: 0px 3px 6px #00000029;
display: flex;
align-items: center;
z-index: 999;
`;

export const TitleWrapper = styled.div`
flex: 1;
`;

export const Title = styled.div`
font-size: 20px;
font-weight: 600;
color: #fff;
text-transform: capitalize;
line-height: 1.5;

@media (max-width: 768px) {
  font-size: 18px;
}

@media (max-width: 480px) {
  font-size: 16px;
}
`;

export const NameText = styled.div`
font-size: 14px;
font-weight: 400;
color: #fff;
line-height: 1.5;
@media (max-width: 768px) {
  font-size: 16px;
}

@media (max-width: 480px) {
  font-size: 12px;
}
`;

export const Logo = styled.img.attrs({
    alt: 'logo',
    src: logo,
})`
width: 50px;
`;
